import React from "react";
import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import "./testimonials.css";
import "swiper/css";
import "swiper/css/pagination";
import Image1 from "../../assets/avatar-1.svg";
import Image3 from "../../assets/avatar-3.svg";

const data = [
  {
    id: 1,
    image: Image1,
    title: "Atmam El-Faruq",
    subtitle: "Programmer at AKSI Teknologi",
    comment:
      "I enjoy working and learning together. I hope you will be successful in the future and see you soon. Good luck! 👍",
  },
  {
    id: 2,
    image: Image3,
    title: "Fadlil Sangaji",
    subtitle: "Project Manager at AKSI Teknologi",
    comment:
      "Thank you for your hard work, I hope you will learn a lot while working together. I am glad to see you studying seriously during this time.",
  },
];

const Testimonials = () => {
  return (
    <section className="testimonials container section">
      <h2 className="section__title">Clients & Reviews</h2>

      <Swiper
        className="testimonials__container grid"
        modules={[Pagination]}
        spaceBetween={30}
        slidesPerView={1}
        loop={true}
        grabCursor={true}
        pagination={{ clickable: true }}
      >
        {data.map(({ id, image, title, subtitle, comment }) => {
          return (
            <SwiperSlide className="testimonial__item" key={id}>
              <div className="thumb">
                <img src={image} alt="" />
              </div>
              <h3 className="testimonials__title">{title}</h3>
              <span className="subtitle">{subtitle}</span>
              <p className="comment">{comment}</p>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </section>
  );
};

export default Testimonials;
